<template>
    <div class="medicinal_body">
        <div class="medicinal_con_line">
            <el-col class="line_span_left" :span="18">
                <span class="mrr10"><el-tag effect="dark" size="default"><span>{{ billingTypeName }}</span></el-tag></span>
                <span class="med_line_span font_gold font_weight">共 {{medicineTotle}} 味药材，总重量 {{ medicineHeavy }} g，共 {{ medCountPrice }} 元 </span>
            </el-col>
            <el-col class="line_span_right" :span="6">
                <el-button type="success" round @click="sureEditPopup()">保存</el-button>
            </el-col>
        </div>
        <div class="medicinal_con_line">
            <el-col class="line_span_left" :span="18">
                <el-button type="warning" round v-if="pagename === 'clinictreat'" @click="openPrescriptionDrew()">导入处方模版</el-button>
                <el-button type="danger" round @click="cleanAllMedicine()">清空药材</el-button>
                <el-button type="primary" round @click="openChangeCountDialog()">按倍改剂量</el-button>
            </el-col>
            <el-col class="line_span_right" :span="6">
                <el-button icon="Plus" type="primary" round @click="toAddMedical()">继续添加</el-button>
            </el-col>
        </div>
        <div class="med_ul_body">
            <div :class="item.changeGcount?'med_line_active':'med_line_body'" v-for="(item, index) in docMedicineArray" :key="index" @click="changeMedGcount(index)">
                <div class="med_line_con" v-if="item.medicineId !== null">
                    <view class="med_status flex_c_between" v-if="item.medicineId !== null && item.medicineId !== '' && item.meStatus !== '0'">
                        <el-col :span="2">
                            <el-button circle size="small" type="danger" @click="removeMedicine(index)">
                                <el-icon><DeleteFilled/></el-icon>
                            </el-button>
                        </el-col>
                        <el-col :span="20">
                            <view class="med_status_info font_16 flex_c_right">当前药材已下架</view>
                        </el-col>
                    </view>
                    <el-col :span="2">
                        <el-button circle size="small" type="danger" @click="removeMedicine(index)">
                            <el-icon><DeleteFilled/></el-icon>
                        </el-button>
                    </el-col>
                    <el-col class="med_name_con" :span="billingType !== '0'?6:8">
                        <div class="med_name">
                            <span class="font_gold" v-if="item.standard !== null && item.standard !== undefined && item.standard !== '' && billingType === '0' && newRuleOpen">[{{item.standard}}]</span>
                            <span>{{ item.meName }}</span>
                        </div>
                        <div class="med_info" v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">{{item.drugProperty}}</div>
                    </el-col>

                    <el-col :span="8" class="med_num" v-if="billingType === '0'">
                        <div v-if="newRuleOpen">
                            <div class="flex_t_col">
                                <div class="flex_c_left" v-if="item.changeGcount">
                                    <el-input-number :controls="false" :ref="'gCount'+item.medicineId" :step="0.1" class="med_num_input" v-model="item.newGCount" placeholder="重量"
                                              @change="changeValue(index)" @blur="blurMedGcount(index)" @focus="focusSelect($event)" @keyup.enter="nextChooseMedicine(index)"></el-input-number>
                                    <div class="med_dan">g</div>
                                </div>
                                <div class="medicine_xin flex_c_left font1rem font_red"
                                     v-if="(item.newGCount !== '' && item.newGCount !== null && item.newGCount !== undefined) && item.changeGcount">转新标<span class="font_w">{{item.gCount}}</span>g</div>
                                <div class="medicine_xin flex_c_left font1rem font_red"
                                     v-if="(item.newGCount === '' || item.newGCount === null || item.newGCount === undefined) && item.changeGcount">未填剂量</div>
                                <div class="medicine_xin_noedit flex_t_col" v-if="item.newGCount !== '' && !item.changeGcount">
                                    <div class="medicine_xin_one flex_c_left"><span class="font_w mrr3">{{item.newGCount}}</span>g</div>
                                    <div class="medicine_xin_two flex_c_left">颗粒量<span class="font_w mrlr3 font_red">{{item.gCount}}</span>g</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!newRuleOpen">
                            <div class="flex_c_left">
                                <el-input-number :controls="false" :ref="'gCount'+item.medicineId" :step="0.1" size="large" class="med_num_input" v-model="item.newGCount" placeholder="重量"
                                          @change="changeValue(index)"  @focus="focusSelect($event)" @keyup.enter="nextChooseMedicine(index)"></el-input-number>
                                <div class="med_dan">g</div>
                            </div>
                        </div>
                    </el-col>

                    <el-col class="med_num" :span="6" v-if="billingType !== '0'">
                        <el-input-number :controls="false" :ref="'gCount'+item.medicineId" :step="0.1" size="large" class="med_num_input" v-model="item.gCount" placeholder="重量"
                                  @change="changeValue(index)"  @focus="focusSelect($event)" @keyup.enter="nextChooseMedicine(index)"></el-input-number>
                        <div class="med_dan">g</div>
                    </el-col>


                    <el-col class="med_price" :span="billingType !== '0'?4:6">
                        <span>￥{{item.mCount}}</span>
                    </el-col>
                    <el-col :span="6" v-if="billingType !== '0'">
                        <el-select class="med_select_style2" v-model="item.decoctionId" placeholder="煎法" @change="chooseJianfa(item)">
                            <el-option :label="decItem.decoctionName" :value="decItem.decoctionId" v-for="(decItem, decIndex) in decoctionList" :key="decIndex"></el-option>
                        </el-select>
                    </el-col>
                </div>

                <div class="med_line_con" v-if="item.medicineId === null">
                    <el-select ref="medSelectInput"
                        class="med_select_style"
                        v-model="chooseMedicineId"
                        filterable
                        remote
                        placeholder="药品名称"
                        :remote-method="qryMedicineList"
                        @change="sureChooseMedicine(index)"
                        @keyup.enter="sureChooseMedicine(index)"
                    >
                        <el-option
                            v-for="itm in medRange"
                            :key="itm.value"
                            :label="itm.text"
                            :value="itm.value"
                        >
                            <span style="float: left">{{ itm.text }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ itm.ratioPrice }}元/g</span>
                        </el-option>
                    </el-select>
                </div>


            </div>
        </div>
    </div>


    <!-- 导入处方模版-->
    <el-drawer :with-header="false" v-model="prescriptionDialogVisible" :direction="direction" destroy-on-close
               size="32%"
               style="background: #f5f7fa">
        <div class="drawer_con">
            <div class="drawer_title">
                <span>导入处方模版</span>
                <el-icon class="drawer_icon"  @click="getPreDrawerStatus()">
                    <close-bold/>
                </el-icon>
            </div>
            <Prescription @preDrawerStatus="getPreDrawerStatus()"></Prescription>
        </div>
    </el-drawer>


    <!-- 按倍改剂量-->
    <el-dialog v-model="changeMedCountDialogVisible" title="按倍改剂量" width="500" center @close="closeCenterPopup()">
        <div class="medCount_line">
            <div class="medCount_line_left">选择修改倍数：</div>
            <div class="medCount_line_right"><el-input-number @change="changeMultipleValue()" v-model="multipleValue" :step="1" step-strictly /></div>
        </div>
        <div class="medCount_line">
            <div class="medCount_line_left">当前总剂量：</div>
            <div class="medCount_line_right">{{ medicineHeavy }}g</div>
        </div>
        <div class="medCount_line">
            <div class="medCount_line_left">修改后总剂量：</div>
            <div class="medCount_line_right">{{ multipleHeavy }}g</div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="closeCenterPopup()">取 消</el-button>
                <el-button type="primary" @click="sureEditNum()">确 定</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import medicinal from "@/assets/scripts/components/medicinal";
export default medicinal;
</script>

<style scoped lang="scss">
@import "@/assets/styles/medicinal.scss";
</style>